import { MunicipalPropertyRegisterFilter } from "./municipal-property-register-filter.model";

export const EMPTY_MUNICIPAL_PROPERTY_REGISTER_FILTER: Readonly<MunicipalPropertyRegisterFilter> = {
  year: null,
  search: "",
};
